import {Component, Input} from '@angular/core';
import {DashboardBoxesHeadData} from "../../interfaces/dashboard-boxes-head-data";
import {StatisticsLineCharBlockData} from "../../interfaces/statistics-line-char-block-data";
import {ChartComponentData} from "../../interfaces/chart-component-data";
import {LineChartCategory} from "../../interfaces/line-chart-category";

@Component({
  selector: 'brt-statistics-line-chart-block',
  templateUrl: './statistics-line-chart-block.component.html',
  styleUrls: ['./statistics-line-chart-block.component.scss']
})
export class StatisticsLineChartBlockComponent {

  @Input('data') set setData(data: Partial<StatisticsLineCharBlockData>) {
    this.data = {
      ...this.data,
      ...data
    }

    this.data.headlineBlockData = {
      ...this.defaultHeadlineBlockData,
      ...data.headlineBlockData
    }

    this.currentCategory = this.data.categories[0];

    this.chartComponentData.data = this.data.categories[0];
  }

  data: StatisticsLineCharBlockData = {
    headlineBlockData: {},
    categories: []
  }

  defaultHeadlineBlockData: Partial<DashboardBoxesHeadData> = {
  }

  currentCategory!: LineChartCategory;


  chartComponentData: ChartComponentData = {
    type: "line",
    data: {
      datasets: []
    }
  }

  setCategory(category: LineChartCategory) {
    this.currentCategory = category;
    this.chartComponentData.data = category;
    this.chartComponentData = {...this.chartComponentData};
  }
}
